export default __webpack_public_path__ + "shoec41bc5.jpg";